// extracted by mini-css-extract-plugin
export default {"root":"Package_root__wGHhB","description":"Package_description__oMoeb","buttonPriceContainer":"Package_buttonPriceContainer__49UnX"};